<div class="share-with-contacts-container">
  <div class="instructions fx--mt-8 fx--mb-8">
    <span class="required-icon"> * </span><span class="required-label">Required Fields</span>
  </div>

  <ng-container *ngIf="isLeaseComp && leaseIds?.length">
    <div class="share-warning-container">
      <div class="share-warning-message-container">
        <p class="share-warning-message">{{ 'shared.shareContact.saveSearchWarning' | xTranslate }}</p>
        <mat-checkbox [formControl]="lcplShareSearchCheckControl"></mat-checkbox>
      </div>
      <div class="lease-ids-wrapper">
        <mat-icon
          class="lease-id-icon"
          svgIcon="alert-icon-sharp"
          *ngIf="totalLeaseCount > 20"
          [matTooltip]="'shared.shareContact.shareSearchMoreIdsWarning' | xTranslate"
          matTooltipPosition="above"
        >
          alert
        </mat-icon>
        <div class="lease-ids">
          <ng-container *ngFor="let leaseId of leaseIds | slice: 0 : 20; let isLast = last">
            <a href="javascript:void()" (click)="navigateToLease(leaseId)">{{ leaseId }}</a>
            <span *ngIf="!isLast">,&nbsp;</span>
          </ng-container>
          <ng-container *ngIf="totalLeaseCount > 20">
            <div>...</div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Email Notes -->
  <div class="notes-container">
    <div class="notes-container__label">{{ notesLabel || ('shared.shareContact.notesLabel' | xTranslate) }}</div>

    <mat-form-field floatLabel="never" appearance="outline" class="notes-container__input">
      <textarea
        matInput
        autocomplete="no-autofill"
        [placeholder]="notesPlaceHolder || 'shared.shareContact.notesPlaceholder' | xTranslate"
        [formControl]="notesControl"
      ></textarea>
    </mat-form-field>
  </div>

  <!-- List of contacts -->
  <miq-contact-list
    [contactList]="contactList"
    [searchControl]="searchControl"
    (selectionChange)="onSelectionChange($event)"
  ></miq-contact-list>

  <mat-divider></mat-divider>
  <!-- Actions section -->
  <div class="actions-container">
    <button
      mat-flat-button
      color="primary"
      class="actions-container__button"
      (click)="onShare()"
      [disabled]="!selectedUsers.length || (isLeaseComp && leaseIds?.length && !lcplShareSearchCheckControl.value)"
    >
      {{ 'shared.shareContact.share' | xTranslate }}
    </button>
  </div>
</div>
